import React, { useState } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";

import Row from "./Row";

import { customers } from "../../../../mocks/customers";

const Table = ({ data, className, activeTable, setActiveTable }) => {
  const [activeId, setActiveId] = useState(customers[0].id);

  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleChange = (id) => {
    if (selectedFilters.includes(id)) {
      setSelectedFilters(selectedFilters.filter((x) => x !== id));
    } else {
      setSelectedFilters((selectedFilters) => [...selectedFilters, id]);
    }
  };

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={cn(styles.table)}>
        <div className={cn(styles.row, { [styles.active]: activeTable })}>
          <div className={styles.col}>Camera Name</div>
          <div className={styles.col}>Camera</div>
          <div className={styles.col}>Created On</div>
        </div>
        {data?.map((setting, index) => (
          <Row
            item={setting}
            key={index}
            activeTable={activeTable}
            setActiveTable={setActiveTable}
            activeId={activeId}
            setActiveId={setActiveId}
            value={selectedFilters.includes(setting.id)}
            onChange={() => handleChange(setting.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default Table;
